module.exports = __webpack_public_path__ + "media/audio109.d70027e5.mp3";